
@switch (deliveryMethod) {
  @case ('Flugzeug') {
    <i class="fa fa-plane ev-cn-order-blue-color"
      [title]="deliveryMethod"
      [ngClass]="clazz"
      >
    </i>
  }
  @case ('Zug') {
    <i class="fa fa-train"
      [title]="deliveryMethod"
      [ngClass]="clazz"
      >
    </i>
  }
  @case ('Schiff') {
    <i class="fa fa-ship"
      [title]="deliveryMethod"
      [ngClass]="clazz"
      >
    </i>
  }
  @case ('DHL Express') {
    <i class="fa fa-truck ev-cn-order-dhl-color"
      [title]="deliveryMethod"
      [ngClass]="clazz"
      >
    </i>
  }
}
